var component = require('../../../lib/js/component.js');
var utils = require('../../../lib/js/utils.js');

function PlanFeatures(){
    this.initialize = function (element) {
        var _this = this;
        _this.$allVerticalTabs = _this.find('.plan-feature-tab');
         _this.$allVerticalTabs.on('click', function(e) {
            e.preventDefault();
            var $current = $(e.currentTarget);  
            var idx = _this.$allVerticalTabs.index($current);
            var $tabContent = _this.find(".tab-pane").eq(idx);
            $current.addClass('active').attr('aria-selected', 'true').attr('tabindex', '0').attr('aria-controls', $tabContent.attr('id')).siblings().removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
            $tabContent.addClass('active').siblings().removeClass('active');    
        });
       
        _this.$allVerticalTabs.on('keydown', function(e) {
            var $tabs = _this.$allVerticalTabs;
            var $current = $(e.currentTarget);
            var idx = $tabs.index($current);
            var len = $tabs.length;
            var $tabContent = _this.find(".tab-pane.active");
             $tabs.eq(idx).focus();

             switch(e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    var next = (idx + 1) % len;
                    var tabPanelId =_this.find(".tab-pane").eq(next).attr('id');
                    $tabs.eq(next).focus().addClass('active').attr('aria-selected', 'true').attr('tabindex', '0').attr('aria-controls', tabPanelId).siblings().removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
                    $tabContent = _this.find(".tab-pane").eq(next);
                    $tabContent.addClass('active').siblings().removeClass('active');
                    break;
                    
                case 'ArrowUp':
                    e.preventDefault();
                    var prev = (idx - 1 + len) % len;
                    var tabPanelIdPrev =_this.find(".tab-pane").eq(prev).attr('id');
                    $tabs.eq(prev).focus().addClass('active').attr('aria-selected', 'true').attr('tabindex', '0').attr('aria-controls', tabPanelIdPrev).siblings().removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
                    $tabContent = _this.find(".tab-pane").eq(prev);
                    $tabContent.addClass('active').siblings().removeClass('active');
                    break;
                default:
                    break;
            }            
        });
    }
}

module.exports = component(PlanFeatures);
